module.exports = __webpack_public_path__ + "img/late_cancel_icon.30a8123b.svg";